import angular from 'angular';
import template from './progress-button.html';
function increment(stat) {
    return 6 * Math.exp(-5 * (stat / 100));
}
const dProgressButtonPromise = ($interval, $timeout, $q, notificationFactory) => {
    return {
        template,
        restrict: 'A',
        scope: {
            promise: '=dProgressButtonPromise',
            progressValue: '=dProgressValue',
            disabledBtn: '=?dDisabled',
        },
        transclude: true,
        link: function (scope, element, attrs) {
            const slowFactor = Boolean(attrs.dSlow) ? Number.parseInt(attrs.dSlow) : 1;
            const bar = angular.element(element[0].querySelectorAll('.progress-inner'));
            const reset = Boolean(attrs.dProgressReset)
                ? scope.$eval(attrs.dProgressReset)
                : {
                    error: true,
                    success: true,
                };
            let innerPromise = null;
            function isDisabledBtn() {
                return Boolean(scope.disabledBtn) ? scope.disabledBtn() : false;
            }
            function startProgress() {
                let value = 0;
                element.addClass('progress-loading');
                element.attr({ disabled: !isDisabledBtn() });
                innerPromise = $interval(function () {
                    value = angular.isNumber(scope.progressValue)
                        ? scope.progressValue
                        : value + increment(value);
                    bar.css({ width: `${value}%` });
                }, 250 * slowFactor);
            }
            async function finishState(isSuccess) {
                const finishClass = `state-${isSuccess ? 'success' : 'error'}`;
                element.addClass(finishClass);
                if ((!reset.error && !isSuccess) || (!reset.success && isSuccess)) {
                    return;
                }
                await $timeout(() => {
                    element.removeClass(finishClass);
                    element.removeClass('progress-loading');
                    element.attr({ disabled: isDisabledBtn() });
                }, 2000);
            }
            async function resetBar() {
                bar.addClass('notransition');
                bar.css({ width: '0' });
                await $timeout(function () {
                    bar.removeClass('notransition');
                }, 250);
            }
            async function progressEnd(isSuccess) {
                $interval.cancel(innerPromise);
                bar.css({ width: '100%' });
                await $timeout(async function () {
                    await resetBar();
                    await finishState(isSuccess);
                }, 500);
            }
            scope.$watch('promise', function (newValue) {
                if (!Boolean(newValue)) {
                    return;
                }
                startProgress();
                $q.when(newValue)
                    .then(progressEnd.bind(null, true))
                    .catch(async (err) => {
                    if (!Boolean(err?.data?.disabledNotification)) {
                        notificationFactory.showError(err);
                    }
                    await progressEnd(false);
                });
            });
        },
    };
};
export default angular
    .module('doxy.common.components.progressButton', [])
    .directive('dProgressButtonPromise', dProgressButtonPromise).name;
